<template>
  <section class="fission-shareSheet-wrapper">
    <MobileShare
      ref="mobileShare"
      @copy-fail="copyFail"
      @copy-success="copySuccess"
      @to-share="toShare"
      @onshow="popupShow"
      hasCallback
      moduleName="fission"
      getContainer=".fission-public-share"
    />
  </section>
</template>

<script>
  import { mapState, mapMutations, mapGetters } from 'vuex'
  import { getHost } from '@/utils/host'
  import { setRouteBase } from '@/config/routePrefix'
  import { getShortUrl } from '@/api/shortUrl'
  import { appShareByWay } from '@/utils/native'
  import { MobileShare } from '@/components/PublicShare/index'

  export default {
    name: 'fission-share-popup',
    components: {
      MobileShare,
    },
    props: {
      page: {
        default: '',
        type: String,
      },
      activitySource: {
        default: '',
        type: String,
      },
    },
    data() {
      return {}
    },
    computed: {
      ...mapState([
        'isMobile',
        'region',
        'isDesktop',
        'userInfo',
        'shareReportStatus',
        'fissionInfos',
        'gameName',
        'isApp',
      ]),
      ...mapGetters(['isNew', 'isNewClass']),
      commonQueryString() {
        return `source=share${
          this.activitySource ? '&activitySource=' + this.activitySource : ''
        }`
      },
    },
    watch: {
      shareReportStatus() {},
    },
    created() {},
    methods: {
      ...mapMutations(['setShareInfos', 'setShareInfosReportFinished']),
      switch() {
        this.$refs.mobileShare && this.$refs.mobileShare.switch()
      },
      popupShow() {
        this.getCopyText('copyLink')
      },
      async getShareUrl(channelName) {
        const fix = setRouteBase() === '/' ? '' : setRouteBase()
        if (!process.client) {
          return
        }
        const { extraInfo } = this.fissionInfos || {}
        const { title: shareTitle } = extraInfo || {}
        const shareUrl = this.formatShareUrl(channelName)

        this.getShareShortUrl(shareUrl, `${getHost()}${fix}`).then(
          (shortUrl) => {
            const title = shareTitle || this.$t(`common.slogan`)

            const shareInfos = {
              shareTitle,
              shortUrl,
            }

            this.$refs.mobileShare &&
              this.$refs.mobileShare.setShareInfo(shareInfos)

            if (this.isApp) {
              let appShareOptions = JSON.stringify({
                url: shortUrl,
                content: title,
                requireLogin: true,
              })
              appShareByWay(channelName, appShareOptions)
            }
          }
        )
      },

      toShare(item = {}, callback) {
        this.setShareInfos(item)
        this.setShareInfosReportFinished(false)
        this.getCopyText(item.id, callback)
      },

      async getShareShortUrl(url, path) {
        if (!process.client) {
          return
        }
        const code = await getShortUrl(
          window.encodeURIComponent(window.encodeURIComponent(url))
        )
        return `${path}/share/${code}`
      },
      copySuccess() {
        const timeid = setTimeout(() => {
          this.setShareInfos({ id: 'copyLink' })
          clearTimeout(timeid)
        }, 1400)
      },
      copyFail() {},
      getCopyText(channelId, callback) {
        const { extraInfo } = this.fissionInfos || {}
        const fix = setRouteBase() === '/' ? '' : setRouteBase()
        const { kicoinId = '' } = this.userInfo || {}
        if (!kicoinId) {
          return
        }
        const url = this.formatShareUrl(channelId)
        const { title: shareTitle } = extraInfo || {}
        this.getShareShortUrl(url, `${getHost()}${fix}`).then((shortUrl) => {
          const title = shareTitle
            ? shareTitle + ': \n'
            : this.$t(`common.slogan`) + ': \n'
          this.copyText = `${title}${shortUrl}`

          if (channelId === 'copyLink') {
            this.$refs.mobileShare &&
              this.$refs.mobileShare.setCopyText(`${title}${shortUrl}`)
          }

          const shareInfos = {
            shareTitle: shareTitle ? shareTitle : this.$t(`common.slogan`),
            shareUrl: shortUrl,
          }
          callback && typeof callback === 'function' && callback(shareInfos)
        })
      },

      formatShareUrl(channelId) {
        const { kicoinId = '' } = this.userInfo || {}
        const fix = setRouteBase() === '/' ? '' : setRouteBase()
        const slogan = window.abtest_shareQuery_text || 'toplupe'
        const { game = '', activityId } = this.fissionInfos || {}
        const pathName = game || this.gameName
        const url = `${getHost()}${fix}/${pathName}?${
          this.commonQueryString
        }&channelId=${channelId}&attachedKicoinId=${kicoinId}&activityId=${activityId}&platform=h5&slogan=${slogan}`
        return url
      },
    },
  }
</script>
<style lang="scss">
  .fission-shareSheet-wrapper {
    .van-overlay {
      z-index: 2999 !important ;
    }
    .share-popup-wrapper {
      z-index: 3000 !important;
    }
  }
</style>
